import { z } from 'zod';

import { AccessRestrictionMode, PeoStaffBlacklistedEmployeeKindEnum } from 'src/api';

import { AccessRestrictionModeFormField } from '../constants';
import { AccessListItem, AccessRestrictionModeFormValues, EmployeeBlacklistItem } from '../types';

const accessListItemValues = z.object({ id: z.string() }) satisfies z.ZodType<AccessListItem>;

const employeeBlacklistItemValues = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal(PeoStaffBlacklistedEmployeeKindEnum.Existing),
    id: z.string(),
    last4OfSsn: z.string(),
    fullName: z.string().nullish(),
  }),
  z.object({
    kind: z.literal(PeoStaffBlacklistedEmployeeKindEnum.New),
    id: z.string(),
    token: z.string(),
    last4OfSsn: z.string(),
    fullName: z.string().nullish(),
  }),
]) satisfies z.ZodType<EmployeeBlacklistItem>;

export const accessRestrictionModeFormValidationSchema = z
  .object({
    [AccessRestrictionModeFormField.accessRestrictionMode]: z.enum(AccessRestrictionMode),
    [AccessRestrictionModeFormField.employerBlacklist]: z.array(accessListItemValues),
    [AccessRestrictionModeFormField.employeeBlacklist]: z.array(employeeBlacklistItemValues),
    [AccessRestrictionModeFormField.employerWhitelist]: z.array(accessListItemValues),
  })
  // A whitelist with no clients means the user can see no one — almost always a mistake,
  // so require at least one entry. An empty blacklist is a valid "no restrictions" state.
  .refine(
    values =>
      values[AccessRestrictionModeFormField.accessRestrictionMode] !==
        AccessRestrictionMode.Whitelist ||
      values[AccessRestrictionModeFormField.employerWhitelist].length > 0,
    {
      message: 'Add at least one client to the whitelist, otherwise the user will see no one',
      path: [AccessRestrictionModeFormField.employerWhitelist],
    },
  ) satisfies z.ZodType<AccessRestrictionModeFormValues>;
